export default {
  mobile: {
    mapView: false
  }
};
